/**
 * Dev mode — run the app locally (or as a branch preview) with no backend and
 * no real login. See docs/DEV_MODE.md.
 *
 * Off by default in production builds; controlled by VITE_DEV_AUTH_BYPASS.
 */
export {
  DEV_LABEL,
  DEV_ORG,
  DEV_TOKENS,
  DEV_USER,
  isDevAuthBypass,
  seedDevAuth,
} from "./devAuth";
export {
  installDevApiMock,
  jsonResponse,
  paginated,
  registerDevMockRoutes,
  type DevMockHandler,
} from "./mockApi";

import { isDevAuthBypass, seedDevAuth } from "./devAuth";
import { installDevApiMock } from "./mockApi";

/** Seed the fake session and install the API mock. No-op unless the bypass is active. */
export function initDevMode(): void {
  if (!isDevAuthBypass()) return;
  seedDevAuth();
  installDevApiMock();
}
